<template>
  <section id="contact-us" class="container section">
    <Block title="contact_us">
      <form class="form">
        <div class="field">
          <label class="label"
            >{{ t("contact.name") }}
            <CustomInput v-model="name" type="text" input-type="username" />
          </label>
        </div>

        <div class="field">
          <label class="label"
            >{{ t("contact.email") }}
            <CustomInput v-model="email" input-type="email" type="email" />
          </label>
        </div>

        <div class="field">
          <label class="label"
            >{{ t("contact.subject") }}
            <CustomInput v-model="subject" input-type="text" type="text" />
          </label>
        </div>

        <div class="field">
          <label class="label"
            >{{ t("contact.message") }}
            <CustomTextArea v-model="message" rows="4" class="textarea" />
          </label>
        </div>

        <div class="field center">
          <RippleButton
            class="buttom"
            type="prime"
            :disabled="isLoading"
            @click.stop="send"
          >
            {{ t("contact.send") }}
          </RippleButton>
        </div>
      </form>
    </Block>
  </section>
</template>

<script setup>
import Block from "../components/common/Block.vue";
import RippleButton from "../components/common/form/Button.vue";
import CustomInput from "../components/common/form/Input.vue";
import CustomTextArea from "../components/common/form/TextArea.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { HTTP } from "@/api";
import { getCurrentInstance } from "vue";

const { t } = useI18n();
const { proxy } = getCurrentInstance();

const name = ref("");
const email = ref("");
const subject = ref("");
const message = ref("");
const isLoading = ref(false);

const send = async () => {
  if (isLoading.value) return;

  const data = {
    name: name.value.trim(),
    email: email.value.trim(),
    subject: subject.value.trim(),
    message: message.value.trim(),
  };

  const isValid = Object.values(data).every((val) => val.length >= 3);
  if (!isValid) {
    proxy.$notify({
      type: "error",
      title: `❌ ${t("error")}`,
      text: "Enter more than 2 characters",
    });
    return;
  }

  const emailPattern =
    /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\\.,;:\s@\"]+\.)+[^<>()[\]\\.,;:\s@\"]{2,})$/i;
  if (!emailPattern.test(data.email)) {
    proxy.$notify({
      type: "error",
      title: `❌ ${t("error")}`,
      text: "Wrong e-mail format",
    });
    return;
  }

  isLoading.value = true;

  try {
    const res = await HTTP.post("/contact_us", data);
    if (res.data.success) {
      proxy.$notify({
        type: "success",
        title: `🎉 ${t("Success")}`,
        text: "Message was sent",
      });
      name.value = "";
      email.value = "";
      subject.value = "";
      message.value = "";
    } else {
      proxy.$notify({
        type: "error",
        title: `❌ ${t("error")}`,
        text: "Message wasn't sent",
      });
    }
  } catch (err) {
    proxy.$notify({
      type: "error",
      title: `❌ ${t("Error")}`,
      text: "Message wasn't sent",
    });
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped lang="scss">
#contact-us {
  .label {
    font-size: 24px;
  }

  .buttom {
    width: 250px;
  }

  .center {
    display: flex;
    justify-content: center;
  }

  .field {
    margin-bottom: 5px;
  }
}
</style>
